
import {BufferGeometry, Mesh, Object3D} from "three";
import {mergeGeometries} from "three/examples/jsm/utils/BufferGeometryUtils";

export function extractCombinedGeometry( object: Object3D ): BufferGeometry {

    const geometries: BufferGeometry[] = [];

    object.updateMatrixWorld(true);

    object.traverse((child) => {

        if (!(child instanceof Mesh && child.geometry)) { return; }

        child.updateMatrixWorld(true);
        const cloned = child.geometry.clone();
        cloned.applyMatrix4(child.matrixWorld);
        geometries.push(cloned);

    });

    if (geometries.length === 0) { return new BufferGeometry(); }

    return mergeGeometries(geometries);
}